<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  value?: number;
}>();

const percent = computed(() => {
  return props.value != null ? Math.max(0, Math.min(100, props.value)) : 0;
});
</script>

<template>
  <div class="relative h-2 w-full overflow-hidden rounded-full bg-secondary">
    <div
      class="h-full w-full flex-1 bg-primary transition-all"
      :style="{ transform: `translateX(-${100 - percent}%)` }"
    />
  </div>
</template>
